var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.203,
    height: 15.203,
    viewBox: "0 0 15.203 15.203",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "About",
    transform: "translate(-1965 -788)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1673",
    "data-name": "Group 1673",
    transform: "translate(1965 788)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1223",
    "data-name": "Path 1223",
    d: "M1972.6,788a7.6,7.6,0,1,0,7.6,7.6A7.61,7.61,0,0,0,1972.6,788Zm0,13.818a6.216,6.216,0,1,1,6.216-6.216A6.224,6.224,0,0,1,1972.6,801.818Z",
    transform: "translate(-1965 -788)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1224",
    "data-name": "Path 1224",
    d: "M1974.818,795.338a.721.721,0,0,0-.729.714v6.037a.729.729,0,0,0,1.458,0v-6.037A.721.721,0,0,0,1974.818,795.338Z",
    transform: "translate(-1967.217 -790.017)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58",
    "data-name": "Ellipse 58",
    cx: 0.752,
    cy: 0.752,
    r: 0.752,
    transform: "translate(6.85 3.058)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.54af3c20.svg";
export { ForwardRef as ReactComponent };